import { render } from "./icon_drag.vue?vue&type=template&id=48fe12a0"
import script from "./icon_drag.vue?vue&type=script&lang=js"
export * from "./icon_drag.vue?vue&type=script&lang=js"

import exportComponent from "/data/build/bruenor/tmp-docuseal/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__